export default {
  title: 'Apply',
  name: {
    lastName: 'Historical Name',
    required: 'Cannot be empty',
    label: 'Creative Name',
    prefixLabel: 'Creative Name Prefix',
    suffixLabel: 'Creative Name Suffix',
    code: {
      projectId: 'Project ID',
      projectName: 'Project Name',
      versionName: 'Version Name',
      outputName: 'Work Name',
      platform: 'Mobile OS',
      autoIncrement: 'Auto Number',
      creative_version: 'Creative Version',
    },
    validate: {
      repeat: 'The creative name already exists.',
    },
  },
  package: {
    size: 'Actual package {size} {symbol} {limit}',
    packError: 'Package calculation error. Retry.',
  },
  channel: {
    title: 'Platform',
    selectAll: 'Select All',
    selectReverse: 'Reverse Election',
    selectCount: 'Select ({count})',
    selectClear: 'Clear',
    selectTips: 'Please select an account or product',
    emptyTips: 'No available accounts or products',
    removeMintegral:
      'Deleting the main account will also delete the sub-accounts under it. Are you sure to delete?',
    removeUnity:
      'Deleting the account will also delete the products under that account. Are you sure to delete?',
    account: 'Account',
    accountMain: 'Main Account',
    accountChild: 'Sub-account',
    product: 'Product',
    creativeSet: 'Creative Set',
    inexistence: {
      product: 'No products associated with the current project were found.',
    },
    applovinTooltip: 'Applovin allows only one playable ad per Creative Set.',
  },
  mtg: {
    save: {
      label: 'Mintegral Archive Download',
    },
  },
}
